const sortNotification = (arr) => {
  return _(arr)
    // group by notificationsSeen
    .sortBy('notificationsSeen')
    .groupBy('notificationsSeen')
    .map((el, key) => (
      key === 'true'
        ? _.orderBy(el, 'commentTime', 'desc')
        : _(el)
            .groupBy('commentType')
            .map((obj, index) => (
              index == 'addFile'
                ? _.orderBy(obj, 'commentTime', 'desc')
                // count comments
                : _(obj)
                    .orderBy('commentTime', 'desc')
                    .groupBy('userFullName')
                    .map((task) => (
                      _(task)
                        .groupBy('link')
                        .map(function (link) {
                          link = _.orderBy(link, 'commentTime', 'desc')
                          link[0].commentCount = link.length
                          return link[0]
                        })
                        .flatten()
                        .value()
                    ))
                    .flatten()
                    .value()
            ))
            .flatten()
            .orderBy('commentTime', 'desc')
            .value()
    ))
    .flatten()
    .orderBy('commentTime', 'desc')
    .value()
}

export const ProjectNotifications = {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    getProjectNotifications (state, rootGetters) {
      let taskList = [...rootGetters.getActiveTaskList]
      let notifications = []

      let notificationComments = []
      let item = {}

      let notificationFiles = []
      let itemFile = {}

      if (taskList) {
        _.forEach(taskList, function (task) {
          _.forEach(task.designerFileList, function (designerFile) {
            // add comments file
            itemFile = {
              'taskName': task.title,
              'taskId': task.id,
              'commentTime': designerFile.created,
              'userFirstName': designerFile.userFirstName,
              'userSecondName': designerFile.userSecondName,
              'userFullName': designerFile.userFirstName + ' ' + designerFile.userSecondName,
              'commentType': 'addFile',
              'link': designerFile.uuid,
              'notificationsSeen': designerFile.seenDesignerFile,
              'fileName': designerFile.designerFileKey
            }
            notificationFiles.push(itemFile)
            // add comments
            _.forEach(designerFile.fileCommentList, function (commentList) {
              item = {
                'taskName': task.title,
                'taskId': task.id,
                'commentTime': commentList.timestamp,
                'userFirstName': commentList.userFirstName,
                'userSecondName': commentList.userSecondName,
                'userFullName': commentList.userFirstName + ' ' + commentList.userSecondName,
                'comment': commentList.comment,
                'commentType': 'addComment',
                'link': designerFile.uuid,
                'notificationsSeen': commentList.seenComment
              }
              notificationComments.push(item)
              _.forEach(commentList.fileCommentReplyList, function (commentListReplay) {
                item = {
                  'taskName': task.title,
                  'taskId': task.id,
                  'commentTime': commentListReplay.timestamp,
                  'userFirstName': commentListReplay.userFirstName,
                  'userSecondName': commentListReplay.userSecondName,
                  'userFullName': commentListReplay.userFirstName + ' ' + commentListReplay.userSecondName,
                  'comment': commentListReplay.comment,
                  'commentType': 'addComment',
                  'link': designerFile.uuid,
                  'notificationsSeen': commentList.seenComment
                }
                notificationComments.push(item)
              })
            })
          })
        })
      }

      notifications = sortNotification(notificationComments.concat(notificationFiles))

      return notifications
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Projectnotifications.js